<section class="tw-w-full">
  <div class="p-1 w-full xl:w-1/2" *ngIf="input_src && isValidImage">
    <!-- [ngClass]="[
    imageType != HelpFileTypes.File && imageType != HelpFileTypes.Pdf
      ? 'tw-cursor-pointer'
      : '',
    imageClass
  ]" -->
    <img
      content
      [imageViewer]="
        imageType != HelpFileTypes.File && imageType != HelpFileTypes.Pdf
      "
      [width]="input_imgWidth"
      [height]="input_imgHeight"
      [style]="input_style"
      [style.width]="input_imgWidth"
      [style.height]="input_imgHeight"
      [src]="input_src"
      class="max-h-full object-contain cursor-pointer w-12 h-8 rounded-sm img-preview"
    />
  </div>

  <span
    *ngIf="!input_src && isValidImage"
    [style.width]="input_imgWidth"
    [style.height]="input_imgHeight"
    class="tw-flex-center flex-column empty"
  >
    <i class="mdi mdi-image-off mdi-48px"></i>
    <p class="tw-mt-2">{{ "messages.fileNotUploaded" | translate }}</p>
  </span>

  <span
    *ngIf="!isValidImage"
    [style.width]="input_imgWidth"
    [style.height]="input_imgHeight"
    class="tw-flex-center flex-column empty"
  >
    <i class="mdi mdi-alert-circle-outline mdi-48px"></i>
    <p class="tw-mt-2">{{ "messages.fileIsInvalid" | translate }}</p>
  </span>
</section>
